import React, { useEffect, useRef, useState } from "react";
import Notifications from "../../../../components/Notifications/Notifications";
import { IoMdNotificationsOutline } from "react-icons/io";
import { useStateValue } from "../../../../StateProvider";
import { useForm } from "react-hook-form";
import {
  editeAttachments,
  editeUser,
  getEditeAttachmentsData,
  getSignupReDetail,
  signup,
  uploadAttachmets,
} from "../../../../apiCall";
import { IoIosCloseCircle } from "react-icons/io";

import toast from "react-hot-toast";
import { DateToYYYYMMDD } from "../../../../utils/FormateDate";
import { NewPasswordModal } from "../../../../components/Modals/NewPasswordModal";
import { useParams } from "react-router-dom";
import { MAX_FILE_SIZE } from "../../../../Constants";
import { useQuery } from "@tanstack/react-query";
import { validateNoBlankSpaces } from "../../../../utils/formValidation";

const AddUpdateAttachment = ({
  setActiveTab,
  setNwAddedAttechment,
  setAttachmentCount,
  setAttchmentId,
  editAttchmentId,
  setEditAttchmentId,
  setTitle,
  attachmentType,
  AttchType,
  TranType,
  staffId,
}) => {
  const [tab, setTab] = useState("information");
  const [{ sysConfig }, dispatch] = useStateValue();
  const [file, setFile] = useState("");
  const [fileName, setFileName] = useState("");
  const [fileError, setFileError] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const { taskId, subtaskId, projectId, temId } = useParams();
  const [uploading, setUploading] = useState(false);
  const [perentId, setPerentId] = useState();
  const imageRef = useRef();

  // ********************************************** handle image change start ****************************************************
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    console.log(file.name);
    setValue("file", file);
    setFileName(file.name);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const files = e.dataTransfer.files;
    console.log(files);
    if (files && files.length > 0) {
      setValue("file", files[0]);
      setFileName(files[0].name);
    }
  };
  // ********************************************** handle image change end ****************************************************

  // ********************************************** form start ****************************************************
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      // TranType: 7,
    },
  });
  const onSubmit = async (data) => {
    if (fileName) {
      if (!editAttchmentId) {
        const allowedExtensions =
          sysConfig["Allowed File types for attachment"].split(", ");
        const fileExtension = data.file?.name.split(".").pop().toLowerCase();
        if (
          data.file.size >
          sysConfig["Maximum Attachment Size in MB"] * 1024 * 1024
        ) {
          setFileError(
            `File size must be less than ${sysConfig["Maximum Attachment Size in MB"]} MB`
          );
          setValue("file", "");
          setFileName("");
        } else if (!allowedExtensions.includes(`.${fileExtension}`)) {
          setFileError(
            `Invalid file type. Please select a file with one of the following extensions: ${allowedExtensions.join(", ")}`
          );
          setValue("file", "");
          setFileName("");
        } else {
          setUploading(true);
          dispatch({ type: "SET_LOADING", status: true });

          const formData = new FormData();
          formData.append("file", data.file);
          formData.append("DocNm", data.DocNm);
          formData.append("Dscr", data.Dscr);
          formData.append("TranType", TranType);
          formData.append("AttchType", AttchType);
          if (attachmentType === "company") {
            formData.append("TranMID", 1);
          } else {
            formData.append("TranMID", perentId);
          }
          try {
            await new Promise((resolve) => setTimeout(resolve, 2000));

            const interval = setInterval(() => {
              setUploadProgress((prev) => {
                if (prev >= 100) {
                  clearInterval(interval);
                  setUploading(false);
                  return 100;
                }
                return prev + 10;
              });
            }, 200);
          } catch (error) {
            console.error("Upload failed:", error);
            setUploading(false);
          }
          const re = await uploadAttachmets(formData);

          if (re?.status === 200) {
            toast.success(re?.data?.message);
            setAttchmentId(re?.data?.data);
            setAttachmentCount((prevCount) => prevCount + 1);
            handleTitleChange();
            setActiveTab("attachmentList");
          } else if(re?.response)  {
            toast.error(re?.response?.data?.message);
          }
        }
      } else {
        setUploading(true);
        dispatch({ type: "SET_LOADING", status: true });

        const formData = new FormData();
        formData.append("DocNm", data.DocNm);
        formData.append("TranType", TranType);
        if (attachmentType === "company") {
          formData.append("TranMID", 1);
        } else {
          formData.append("TranMID", perentId);
        }
        formData.append("AttchType", AttchType);
        formData.append("Dscr", data.Dscr);
        try {
          await new Promise((resolve) => setTimeout(resolve, 2000));
          const interval = setInterval(() => {
            setUploadProgress((prev) => {
              if (prev >= 100) {
                clearInterval(interval);
                setUploading(false);
                return 100;
              }
              return prev + 10;
            });
          }, 200);
        } catch (error) {
          console.error("Upload failed:", error);
          setUploading(false);
        }
        const re = await editeAttachments(editAttchmentId, formData);

        if (re?.status === 200) {
          toast.success(re?.data?.message);
          setAttchmentId(editAttchmentId);
          setEditAttchmentId("");
          // setAttachmentCount((prevCount) => prevCount + 1);
          // setTitle("Attachment List");
          handleTitleChange();

          setActiveTab("attachmentList");
        } else if(re?.response)  {
          toast.error(re?.response?.data?.message);
        }
      }
      dispatch({ type: "SET_LOADING", status: false });
    } else {
      setFileError("File is required");
    }
  };
  // ********************************************** form end ****************************************************

  // ********************************************** remove image start ****************************************************
  const removeImage = () => {
    setValue("file", "");
    setFileName("");
  };
  // ********************************************** remove image end ****************************************************
  const [show, setShow] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const handleClose = () => {
    setShow(false);
    setNewPassword("");
  };
  const handleShow = () => setShow(true);

  const fetchTaskAttechments = async () => {
    // Perform the API call to fetch company info
    try {
      dispatch({ type: "SET_LOADING", status: true });

      const response = await getEditeAttachmentsData(editAttchmentId);

      if (response?.status === 200) {
        console.log(response.data?.DocNm);
        setValue("DocNm", response.data.data?.DocNm);
        setValue("Dscr", response.data.data?.Dscr);
        setFileName(response.data.data?.FileNm);
      } else if(response?.response)  {
        toast.error(response.response.data.message);
      }

      dispatch({ type: "SET_LOADING", status: false });
      return response;
    } catch (error) {
      console.error("Error fetching data:", error); // Log any errors that occur
    }
  };
  const { data, refetch } = useQuery({
    queryKey: ["task-attechments"],
    queryFn: fetchTaskAttechments,
    enabled: editAttchmentId ? true : false,
    // staleTime: Infinity,
    onSuccess: (Re) => {
      console.log(Re);
    },
    onError: (e) => {
      console.log(e);
    },
  });
  useEffect(() => {
    if (editAttchmentId) {
      setTitle("Update Attachment");
    } else {
      setTitle("Add Attachment");
    }
  }, [editAttchmentId]);

  useEffect(() => {
    if (staffId) {
      setPerentId(staffId);
    } else if (taskId) {
      setPerentId(taskId);
    } else if (subtaskId) {
      setPerentId(subtaskId);
    } else if (temId) {
      setPerentId(temId);
    } else if (projectId) {
      setPerentId(projectId);
    }
  }, [taskId, subtaskId, projectId, temId, staffId]);

  const handleTitleChange = () => {
    if (attachmentType === "task") {
      setTitle(perentId ? "Update Task" : "Add Task");
    }
     else if (attachmentType === "subTask") {
      setTitle(perentId ? "Update Sub-Task" : "Add Sub-Task");
    } 
     else if (attachmentType === "project") {
      setTitle(perentId ? "Update Project" : "Add Project");
    } 
    else if (attachmentType === "projectTemp") {
      setTitle(
        perentId ? "Update Project Template Form" : "Add Project Template Form"
      );
    } else if (attachmentType === "taskTemp") {
      setTitle(
        perentId ? "Update Task Template Form" : "Add Task Template Form"
      );
    } else if (attachmentType === "subTaskTemp") {
      setTitle(
        perentId ? "Update SubTask Template Form" : "Add SubTask Template Form"
      );
    } else if (attachmentType === "company") {
      setTitle("Update Company");
    } else if (attachmentType === "staff") {
      setTitle(staffId ? "Update Staff" : "Add Staff");
    }
  };

  return (
    <div className="col-xl-12 col-md-12 col-12">
      {/* card */}
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="card mb-5">
          {/* card body */}
          <div className="card-body">
            {/* form */}
            <div className="row">
              {/* form group */}
              <div className="mb-4 col-md-12 col-12">
                <label className="form-label">
                  Document Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter name"
                  {...register("DocNm", {
                    required: "Name is required",
                    validate: validateNoBlankSpaces,
                  })}
                />
                {errors.DocNm && (
                  <div className="error">{errors.DocNm.message}</div>
                )}
              </div>
              {/* form group */}
              <div className="mb-4 col-md-12 col-12">
                <label className="form-label">
                  Description <span className="text-danger">*</span>
                </label>
                <textarea
                  type="text"
                  className="form-control"
                  rows={4}
                  placeholder="Enter description"
                  {...register("Dscr", {
                    required: "Description is required",
                    validate: validateNoBlankSpaces,
                  })}
                />
                {errors.Dscr && (
                  <div className="error">{errors.Dscr.message}</div>
                )}
              </div>

              {/* form group */}
              <div className="mb-4 col-md-12 col-12">
                <label className="form-label">
                  Attachment {/* <span className="text-danger">*</span> */}
                </label>
                <div
                  className={`${
                    editAttchmentId ? "disabled" : ""
                  } d-flex justify-content-center align-items-center dropzone border-dashed min-h-0 rounded-2 dz-clickable `}
                >
                  <div
                    className="dz-default dz-message"
                    onDragOver={handleDragOver}
                    onDrop={handleDrop}
                  >
                    <div className="dz-button" type="button">
                      {!fileName ? (
                        <div
                          className="p-7"
                          onClick={() => imageRef.current.click()}
                        >
                          {" "}
                          Drag-Drop or Upload File
                        </div>
                      ) : (
                        <></>
                      )}

                      {fileName ? (
                        <div className="image-wrapper">
                          <h5 className="me-3">{fileName}</h5>
                          {!editAttchmentId && uploading && (
                            <div className="text-center">
                              Uploading {uploadProgress}%
                            </div>
                          )}

                          {!editAttchmentId && (
                            <div
                              className="remove-img"
                              onClick={() => removeImage()}
                            >
                              <IoIosCloseCircle size={20} />
                            </div>
                          )}
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                    {console.log(sysConfig)}
                    <input
                      // disabled={!editStatus}
                      type="file"
                      ref={imageRef}
                      accept={`${sysConfig["Allowed File types for attachment"]}`}
                      onChange={handleFileChange}
                      className="d-none"
                    />
                  </div>
                </div>
                {fileError && <div className="error">{fileError}</div>}
              </div>
            </div>
            <div className="mt-4 d-flex justify-content-between">
              <div
                className="btn btn-outline-danger "
                onClick={() => {
                  setActiveTab("attachmentList");
                  setEditAttchmentId("");
                  setAttchmentId(editAttchmentId);
                  // setTitle("Attachment List");
                  handleTitleChange();
                }}
              >
                Cancel
              </div>
              <button className="btn btn-primary me-2">Save</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddUpdateAttachment;
